import { RARITY_LABEL, RARITY_CLASS } from "@/lib/rarity";
import { API } from "@/lib/api";
import { Download } from "lucide-react";

export function UnknownTile() {
  return (
    <div className="pick-tile opacity-50">
      <div className="tarot-card flex items-center justify-center text-3xl font-display text-[color:var(--text-3)]">?</div>
    </div>
  );
}

export default function CardTile({ cardId, rarity, hasPrize, count = 1, instances = [], children }) {
  return (
    <div className="pick-tile">
      <div className="tarot-card relative">
        <img src={`/cards/card-${String(cardId).padStart(2, "0")}.jpg`} alt="" className="card-img"
          style={hasPrize ? { boxShadow: "0 0 24px rgba(212,175,55,0.6)" } : {}} />
        {count > 1 && (
          <span className="absolute top-1 right-1 bg-black/70 text-gold text-xs font-bold px-1.5 py-0.5 rounded">×{count}</span>
        )}
      </div>
      <div className={`mt-1 text-center text-[10px] md:text-xs uppercase tracking-wide px-1 py-0.5 rounded border ${RARITY_CLASS[rarity]}`}>
        {RARITY_LABEL[rarity]}{hasPrize ? " · 🏆" : ""}
      </div>
      {instances.map(i => (
        <a key={i.card_instance_id} href={`${API}/cards/${i.card_instance_id}/pdf`}
          target="_blank" rel="noreferrer"
          className="mt-1 flex items-center justify-center gap-1 text-[10px] text-gold underline">
          <Download size={10} /> {cardId}/{i.series_total ?? 33} · Lote {i.series_edition ?? 1}
        </a>
      ))}
      {children}
    </div>
  );
}
